<div class="ehe-app-layout" [class.ehe-app-layout-auth]="auth" [class.with-sidebar]="auth">
	<!-- Sidebar (auth only) -->
	<app-sidebar-navigation
		*ngIf="header && auth"
		[auth]="auth"
		[wellness]="wellness"
		[isSimplified]="isSimplified"
		[isOpen]="sidebarOpen"
		[isCollapsed]="true"
		(toggleSidebar)="toggleSidebar()"
		(collapseSidebar)="collapseSidebar($event)"
		(profileRelatedInfo)="profileRelatedInfo.emit($event)">
	</app-sidebar-navigation>

	<!-- Main content area -->
	<div class="main-content">
		<button
			*ngIf="auth && !sidebarOpen"
			type="button"
			class="mobile-sidebar-toggle"
			(click)="toggleSidebar(); $event.stopPropagation()"
			aria-label="Open menu">
			<svg width="20" height="14" viewBox="0 0 20 14" fill="none" aria-hidden="true">
				<rect y="0" width="20" height="2" rx="1" fill="#0D3D60" />
				<rect y="6" width="20" height="2" rx="1" fill="#0D3D60" />
				<rect y="12" width="20" height="2" rx="1" fill="#0D3D60" />
			</svg>
		</button>
		<ion-content #contentRef>
			<app-ehe-topbar *ngIf="auth && showTopbar" (closeSidebar)="collapseSidebar('close')"></app-ehe-topbar>
			<app-ehe-header
				*ngIf="header && !auth"
				[auth]="auth"
				[isSimplified]="isSimplified"
				[showPhone]="showPhone"
				[healthHistory]="healthHistory"
				[hideLinks]="hideLinks"
				[wellness]="wellness"
				[showMobileBackButton]="showMobileBackButton"
				(profileRelatedInfo)="profileRelatedInfo.emit($event)">
			</app-ehe-header>
			<div class="layout-inner">
				<div *ngIf="wellness && wellnessTabsVisible" #tabsBar class="wellness-tabs-bar">
					<button
						*ngFor="let tab of wellnessTabs"
						class="wellness-tab-item"
						[class.active]="activeWellnessTab === tab.value"
						(click)="navigateWellnessTab(tab.value)">
						{{ tab.label }}
					</button>
				</div>
				<ng-content></ng-content>
				<app-ehe-spinner *ngIf="spinner"></app-ehe-spinner>
			</div>
			<!-- Footer inside ion-content: scrolls with page, not sticky -->
			<app-ehe-footer [socialNetwork]="socialNetwork" *ngIf="footer"></app-ehe-footer>
		</ion-content>
	</div>
</div>
